import React from 'react';
import { FormLayout } from 'modules/campaigns/components';
import { FORM_MODES } from 'modules/campaigns/config';
import { withFormDataProvider } from 'modules/taboola-common-frontend-modules/formData';
import { FormInitBase } from 'modules/taboola-common-frontend-modules/forms';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { ChatStepContent } from '../components/Steps/ChatStepContent';
import { useLandingPageEditorState } from '../hooks/useLandingPageEditorState';
import styles from './landingPageEditor.module.scss';

const LandingPageEditor = ({ onCancel }) => {
    const { submit, submitStep } = useLandingPageEditorState();

    return (
        <FormInitBase>
            <FormLayout hideFooter={true} contentContainerClassName={styles['container']}>
                <div className={styles['header-wrapper']}>
                    <div className={styles['header-container']}>
                        <h2 className={styles['header']}>
                            <FormattedMessage
                                id="landing.pages.form.editor.header"
                                defaultMessage="Edit Landing Page"
                            />
                        </h2>
                    </div>
                </div>
                <ChatStepContent
                    className={styles['chat-wrapper']}
                    containerClassName={styles['chat-container-edit-mode']}
                    mode={FORM_MODES.EDIT}
                    onCancel={onCancel}
                    onSubmit={submit}
                    onChatSubmit={submitStep}
                />
            </FormLayout>
        </FormInitBase>
    );
};

const LandingPageEditorWithFormDataProvider = withFormDataProvider(LandingPageEditor, {
    formContainerId: 'edit-drawer-content-landing-page',
    isNetworkOwnerAllowed: true,
});

export { LandingPageEditorWithFormDataProvider as LandingPageEditor };
